import React from "react";
import PropTypes from "prop-types";

/*
Toggle Switch Component
Note: id is required for ToggleSwitch component to function. Name, currentValue, defaultChecked, Small and onChange are optional.
Usage: <ToggleSwitch id="id" onChange={function (e) { console.log("Checkbox Current State: " + e.target.checked); }} />
*/

class ToggleSwitch extends React.Component {
  state = {
    checked: this.props.defaultChecked,
  };
  
  onChange = (e) => {
    this.state.checked = e.target.checked
    if (typeof this.props.onChange === "function") this.props.onChange(this.state.checked,this.props.id);

  };
  render() {
    let title ='';

    if (this.props.mobileTitle === undefined) {
      title = <div className="search-view-description">{this.props.title}</div>;
    }
    else {
      title = <div className="search-view-description"><span className='d-none d-md-inline'>{this.props.title}</span><span className='d-md-none'>{this.props.mobileTitle}</span></div>;
    }
    return (
      <div className={"block block-unhcr-search block-block-search-text-toggler " + this.props.name}>
        <div className="content">
          <div className="search-filter-toggle">
            {title}
            <label className="toggler-wrapper style-blue">
              <input
                type="checkbox"
                name={this.props.name}
                className="toggle-switch-checkbox"
                id={this.props.id}
                checked={this.state.checked}
                onChange={this.onChange}
              />
              <div className="toggler-slider">
                <div className="toggler-knob"></div>
              </div>
            </label>
          </div>
        </div>
      </div>
    );
  }
}

ToggleSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  onChange: PropTypes.func,
  defaultChecked: PropTypes.bool,
  currentValue: PropTypes.bool,
  title: PropTypes.string,
  mobileTitle: PropTypes.string,
};

export default ToggleSwitch;
